<template>
  <el-card style="height: 710px;overflow-y: scroll;">
    <div class="region">
      <p>影响因素编辑</p>
      <el-button @click="dialogVisible = true">批量处理</el-button>
      <el-table border :data="tableData" :header-cell-style="{ 'background-color': '#f6f6f6' }"
        style="width: 100%;margin-top: 20px;" @select="select" @select-all="select_all">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column align="center" prop="username" width="150px" label="用户名称"></el-table-column>
        <el-table-column align="center" prop="title" label="标题"></el-table-column>
        <el-table-column align="center" prop="conclusion" label="提取内容">
          <template slot-scope="scope">
            <div class="ellipsis-text">{{ scope.row.conclusion }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="create_time" label="创建时间"></el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button @click="editInfluenceFacotrShow(scope.row)" type="text" class="button">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination background :current-page="current_page" layout="prev, pager, next" :page-size="pageSize"
        hide-on-single-page @current-change="changePage" @prev-click="changePage" @next-click="changePage"
        :total="total">
      </el-pagination>

      <el-dialog :modal="false" class="dialog" :visible.sync="dialogVisible" :show-close="false" @close="closeDialog"
        width="30%">
        <el-form>
          <el-form-item label="影响因素">
            <el-select v-model="influence_factor">
              <el-option value="生理因素" label="生理因素"></el-option>
              <el-option value="药物因素" label="药物因素"></el-option>
              <el-option value="疾病因素" label="疾病因素"></el-option>
              <el-option value="其他因素" label="其他因素"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-row class="buttons" type="flex" align="middle" justify="end" style="margin-right: 30px;">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitRegionForm">确定</el-button>
        </el-row>
      </el-dialog>

      <el-dialog :modal="false" title="影响因素编辑" class="dialog" :visible.sync="dialogVisibleForm" :show-close="false"
        @close="closeDialogForm" width="60%">
        <el-descriptions style="margin-top: -20px;" class="margin-top" title="" :column="1" >
          <el-descriptions-item label="用户名">{{select_message.username}}</el-descriptions-item>
          <el-descriptions-item label="标题">{{select_message.title}}</el-descriptions-item>
          <el-descriptions-item label="提取内容">
            <el-input type="textarea" :rows="5" v-model="select_message.conclusion" placeholder=""></el-input>
          </el-descriptions-item>
        </el-descriptions>
        <el-row class="buttons" type="flex" align="middle" justify="end" style="margin-right: 30px;">
          <el-button @click="dialogVisibleForm = false">取消</el-button>
          <el-button type="primary" @click="submitFluenceForm">确定</el-button>
        </el-row>
      </el-dialog>
    </div>
  </el-card>
</template>

<script>
import { edit_intelligent_wizard, get_influence_factor,put_influence_factor } from "@/api/InfluenceFactor";

export default {
  name: 'InfluenceFactorView',
  data: function () {
    return {
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      current_page: 1,
      influence_factor: null,
      dialogVisible: false,
      ids: [],

      select_message: '',
      dialogVisibleForm: false
    }
  },
  methods: {
    editInfluenceFacotrShow(row) {
      this.dialogVisibleForm = true
      this.select_message = row
    },
    submitFluenceForm(){
      put_influence_factor({
        id: this.select_message.id,
        conclusion: this.select_message.conclusion
      }).then((res) => {
        const { data } = res
        if (data['code'] === 200) {
          this.$message.success('编辑成功！')
          this.dialogVisibleForm = false
          this.getRegionData()
        } else {
          this.$message.error(data['error'])
        }
      })
    },
    closeDialogForm() {
      this.dialogVisibleForm = false
      this.select_message = ''
    },
    getRegionData() {
      get_influence_factor(this.page, this.pageSize).then((res) => {
        console.log(res, '影响因素字典')
        const { data } = res
        if (data['code'] === 200) {
          this.tableData = data['data']
          this.total = data.count
        }
      })
    },
    closeDialog() {
      this.influence_factor = ''
      this.dialogVisible = false
    },
    submitRegionForm() {
      console.log(this.influence_factor);
      
      console.log(this.ids, this.influence_factor, '提交影响因素');
      
      edit_intelligent_wizard(this.ids, this.influence_factor).then((res) => {
        const { data } = res
        if (data['code'] === 200) {
          this.$message.success('编辑成功！')
          this.dialogVisible = false
          this.getRegionData()
        } else {
          this.$message.error(data['error'])
        }
      })
    },
    changePage(page) {
      this.page = page
      this.getRegionData()
    },
    select_all(selection) {
      this.ids = selection.map(item => {
        return item.id
      })
    },
    select(selection, row) {
      this.ids = selection.map(item => {
        return item.id
      })
    }
  },
  created() {
    this.getRegionData();
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>
.ellipsis-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
}
</style>
